import React from "react";

const STYLES = {
  // Inquiry
  Open: "bg-blue-50 text-blue-700 border-blue-200",
  Quoted: "bg-indigo-50 text-indigo-700 border-indigo-200",
  Lost: "bg-red-50 text-red-700 border-red-200",
  Converted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  // Quotation
  Draft: "bg-slate-100 text-slate-700 border-slate-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  Revised: "bg-amber-50 text-amber-800 border-amber-200",
  // PO
  Received: "bg-blue-50 text-blue-700 border-blue-200",
  Accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Cancelled: "bg-slate-200 text-slate-700 border-slate-300",
  Closed: "bg-teal-50 text-teal-700 border-teal-200",
  // OA
  Confirmed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  ReleasedToProduction: "bg-teal-50 text-teal-800 border-teal-200",
};

export default function CommercialStatusBadge({ status, className = "" }) {
  const cls = STYLES[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      data-testid={`c-status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 border px-2 py-0.5 rounded text-[11px] font-semibold tracking-wide uppercase font-mono ${cls} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}
